module.exports = __webpack_public_path__ + "img/Weapon_107.66c3a20c.png";